import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Download, Menu, X } from "lucide-react";
import { usePortfolio } from "../../contexts/PortfolioContext";

const NAV_ITEMS = [
  { label: "Work", href: "#projects" },
  { label: "Experience", href: "#experience" },
  { label: "Skills", href: "#skills" },
  { label: "Education", href: "#education" },
  { label: "Gallery", href: "#gallery" },
  { label: "Writing", href: "#articles" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = ({ isDownloading, handleDownload }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { portfolioData } = usePortfolio();
  const location = useLocation();
  const personalInfo = portfolioData.personalInfo || {};

  const name = personalInfo.name || "Aurio Rajaa";

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") setMenuOpen(false);
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  useEffect(() => {
    if (!menuOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [menuOpen]);

  const downloadCv = () => {
    setMenuOpen(false);
    if (handleDownload) handleDownload();
  };

  return (
    <header className="public-navbar">
      <a className="public-skip-link" href="#main-content">
        Skip to content
      </a>

      <nav className="public-nav" aria-label="Primary">
        <div className="container nav-wrapper">
          <Link className="public-brand" to="/" aria-label={`${name} home`}>
            <span className="public-brand-copy">
              <span className="public-brand-name">{name}</span>
              <span className="public-brand-role">
                {personalInfo.title || "Software Engineer"}
              </span>
            </span>
          </Link>

          <ul className="public-nav-links">
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <Link className="public-nav-link" to={`/${item.href}`}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>

          <div className="public-nav-actions">
            <button
              type="button"
              className="btn btn-outline"
              onClick={downloadCv}
              disabled={isDownloading}
            >
              <Download size={15} />
              {isDownloading ? "Preparing..." : "CV"}
            </button>
            <Link className="btn" to="/#contact">
              Let&apos;s talk
            </Link>
          </div>

          <button
            type="button"
            className="public-menu-toggle"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            aria-controls="public-mobile-menu"
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div
          id="public-mobile-menu"
          className="public-mobile-menu"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) setMenuOpen(false);
          }}
        >
          <div className="public-mobile-panel">
            {/* <div className="public-mobile-header">
              <span className="public-mobile-title">Menu</span>
            </div> */}

            <ul className="public-mobile-links">
              {NAV_ITEMS.map((item, index) => (
                <li key={item.href}>
                  <Link
                    className="public-mobile-link"
                    to={`/${item.href}`}
                    onClick={() => setMenuOpen(false)}
                  >
                    {item.label}
                    <span>{String(index + 1).padStart(2, "0")}</span>
                  </Link>
                </li>
              ))}
            </ul>

            <div className="public-mobile-actions">
              <button
                type="button"
                className="btn btn-outline"
                onClick={downloadCv}
                disabled={isDownloading}
              >
                <Download size={15} />
                {isDownloading ? "Preparing CV..." : "Download CV"}
              </button>
              <Link
                className="btn"
                to="/#contact"
                onClick={() => setMenuOpen(false)}
              >
                Start a conversation
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
